import React, { useEffect, useState } from "react";
import "./binnysSelectStyle.css";
import Modal from "components/ui/Modal";
import { Grid, Typography } from "@mui/material";
import apiClient from "lib/api-client";
import { formatDate } from "utils/formatDate";
import { useGlobalContext } from "context/GlobalContext";


const BinnysSelectTableModal = ({ open, setOpen, styleNumber}) => {
  const [selectOrderData, setSelectOrderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };
  const {appliedStartDate, appliedEndDate} = useGlobalContext();
  

  const fetchSelectOrderDetails = async (styleNumber, setLoading, setError) => {
    try {
      setLoading(true);
      setError(null);
      const res = await apiClient.get(`/api/v1/collection/getOrderDetailsByStyleNumber?styleNumber=${styleNumber}&startDate=${appliedStartDate}&endDate=${appliedEndDate}`);
      return res?.data?.data;
    } catch (error) {
      setError("Failed to fetch Select Order details. Please try again.");
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      if (open && styleNumber) {
        (async () => {
          const data = await fetchSelectOrderDetails(styleNumber, setLoading, setError);
          if (data) {
            setSelectOrderData(data || []);
          }
        })();
      }
    }, [open, styleNumber]);



  return (
    <Modal open={open} handleClose={handleClose} style={{ width: "fit-content" }}>
      <Grid container spacing={2}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="main-grid">
          <Typography className="select-header">{styleNumber}</Typography>
        </Grid>
        <Grid
         item 
         sx={{
          paddingTop:"0 !important",
          paddingLeft:"0 !important",
          paddingRight:"0 !important",
          marginLeft:"16px",
          marginTop:"16px",
          borderTop: "1px solid black",
          // borderBottom: "1px solid black"
         }}
         xl={12} lg={12} md={12} sm={12} xs={12} className= {selectOrderData?.length > 10 ? "sub-grid1" :"sub-grid"}>
          {loading ? (
            <h3>Loding ...</h3>
          ) : error ? (
            <h4 style={{ color: "red" }}>{error}</h4>
          ) : (
          <table className="select-table">
            <thead className="table-head">
              <tr>
                <th>Order Number</th>
                <th>Date</th>
                <th>Client Name</th>
                <th>PO No.</th>
                <th>Events</th>
              </tr>
            </thead>
            <tbody className="table-body">
            {selectOrderData && selectOrderData.length > 0 ? (
                  selectOrderData.map((item) => (
                    <tr key={item?.id}>
                      <td>#{item?.orderNumber}</td>
                      <td>{formatDate(item?.createdAt)}</td>
                      <td>{item?.clientName}</td>
                      <td>{item?.purchausOrder || "-"}</td>
                      <td>{item?.eventTypeName || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No Order data available.
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default BinnysSelectTableModal;
